module.exports = __webpack_public_path__ + "site/img/edit.085f3e08.svg";